import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "13",
  fill: "none",
  viewBox: "0 0 16 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.77 0H1.23C.905 0 .592.125.36.346.13.568 0 .868 0 1.182v11.227c0 .101.027.2.078.288a.6.6 0 0 0 .214.215.63.63 0 0 0 .599.025l2.186-1.05 2.186 1.05a.64.64 0 0 0 .55 0L8 11.888l2.186 1.05a.64.64 0 0 0 .55 0l2.187-1.05 2.186 1.05a.64.64 0 0 0 .599-.025.6.6 0 0 0 .214-.215.6.6 0 0 0 .078-.288V1.182c0-.314-.13-.614-.36-.836A1.26 1.26 0 0 0 14.77 0m-3.078 7.682H4.308a.63.63 0 0 1-.435-.173.58.58 0 0 1-.18-.418.58.58 0 0 1 .18-.418.63.63 0 0 1 .435-.173h7.384c.163 0 .32.062.435.173a.58.58 0 0 1 .18.418.58.58 0 0 1-.18.418.63.63 0 0 1-.435.173m0-2.364H4.308a.63.63 0 0 1-.435-.173.58.58 0 0 1-.18-.418.58.58 0 0 1 .18-.417.63.63 0 0 1 .435-.174h7.384c.163 0 .32.063.435.174a.58.58 0 0 1 .18.417.58.58 0 0 1-.18.418.63.63 0 0 1-.435.173"
    }, null, -1)
  ]))]))
}
export default { render: render }